$(document).ready(function(){

  var vW = $(window).width();

  /* popup */








  $('#tasting-house-image .pls-row .col:first-child img').wrap('<div class="wrap-fix"></div>');
  
  $('.footer__blocks-wrapper .footer-block:nth-child(2) a').attr('target','_blank');
  $('.footer__blocks-wrapper .footer-block:nth-child(2) h2').click(function(){
    window.location.href = "/pages/tasting-room/";
  });

  $('.list-menu li:nth-child(4)').append('<div class="sub-menu"><a href="https://cdn.shopify.com/s/files/1/0629/8409/3940/files/pleasebevco-menu-drink.pdf" target="_blank">Drink Menu</a><a href="https://cdn.shopify.com/s/files/1/0629/8409/3940/files/pleasebevco-menu-eat.pdf" target="_blank">Food Menu</a><a href="https://cdn.shopify.com/s/files/1/0629/8409/3940/files/pleasebevco-menu-to-go.pdf" target="_blank">To Go Menu</a></div>');
  $('.list-menu li:last-child').append('<div class="sub-menu"><a href="https://www.ubereats.com/store/please-beverage-co/mXAR69w1WbqVIR9FOjITWQ/3f410773-f687-50e0-bb16-0dbb440413dd?ps=1" target="_blank">Uber Eats</a><a href="https://www.doordash.com/en-CA/store/please!-beverage-co.-vancouver-31537291/?preview=1" target="_blank">Doordash</a></div>');

  $('.list-menu li').mouseover(function(){
    $(this).addClass('open');
  }).mouseleave(function(){
    $('.list-menu li').removeClass('open');
  });

  $('.list-menu li .sub-menu').mouseleave(function(){
    $('.list-menu li').removeClass('open');
  });


  if(vW > 767) {
    $('.footer__blocks-wrapper .footer-block--menu:nth-child(4)').append('<div class="delivery-link"><h2 class="footer-block__heading" style="margin-top:40px;">Delivery</h2><ul class="footer-block__details-content list-unstyled"><li><a class="link link--text list-menu__item list-menu__item--link" href="https://www.ubereats.com/store/please-beverage-co/mXAR69w1WbqVIR9FOjITWQ/3f410773-f687-50e0-bb16-0dbb440413dd?ps=1" target="_blank">Uber Eats</a></li><li><a class="link link--text list-menu__item list-menu__item--link" href="https://www.doordash.com/en-CA/store/please!-beverage-co.-vancouver-31537291/?preview=1" target="_blank">Doordash</a></li></ul></div>');
  } else {
    $('.footer__blocks-wrapper .footer-block--menu:nth-child(2)').append('<div class="delivery-link" style="margin-bottom:20px;"><h2 class="footer-block__heading" style="margin-top:30px;">Delivery</h2><ul class="footer-block__details-content list-unstyled"><li><a class="link link--text list-menu__item list-menu__item--link" href="https://www.ubereats.com/store/please-beverage-co/mXAR69w1WbqVIR9FOjITWQ/3f410773-f687-50e0-bb16-0dbb440413dd?ps=1" target="_blank">Uber Eats</a></li><li><a class="link link--text list-menu__item list-menu__item--link" href="https://www.doordash.com/en-CA/store/please!-beverage-co.-vancouver-31537291/?preview=1" target="_blank">Doordash</a></li></ul></div>');
  }

  

  function fixHeight() {
    
    if(vW > 767) {
      var x = $('#tasting-house-image .pls-row .col:nth-child(2) img').height();
      $('.wrap-fix').css('height',x);
       
     
      
      
    } else {
       
      $('.tasting-room-block img').wrap('<div class="mobile-img-wrap"></div>');
      $('#tasting-house-image .col-8 img').attr('srcset','https://cdn.shopify.com/s/files/1/0629/8409/3940/files/please-tasting-room-03-sm.jpg');

    }
  }

   fixHeight();

  
    $(window).resize(function(){
      fixHeight();
    });


  $('.footer__blocks-wrapper .footer-block:last-child a').attr('target','_blank');


  $('.tasting-room-slider-sm').bxSlider({
        minSlides: 1,
        maxSlides: 1,
        pager: true,
      auto: true,
        wrapperClass: 'tasting-room-slider-sm-wrap'
      });

   $('.tasting-room-slider').bxSlider({
        minSlides: 1,
        maxSlides: 2,
        pager: true,
     auto: true,
        wrapperClass: 'tasting-room-slider-wrap'
      });


  $('.tasting-room-slider-wrap, .tasting-room-slider-sm-wrap').append('<div class="caption-wrap"><div><span>INTERIOR SPACE</span></div></div>');


  
  /* keg */

  $('.product-item-keg').find('.card__heading a').each(function(){
    var x = $(this).text();
    var y = x.replace('20L Keg - ','');
    $(this).text(y);
  });


  $('.product-item-keg').find('button').each(function(){
    var x = $(this).text();
    
    $(this).text('Add to Cart - $189');
  });


  $('.product-item-keg').each(function(){
    
    $(this).find('.please-keg-desc').appendTo($(this).find('.card__inner .card__content'));

  });

  
  $('.product-item-keg .card--standard .card__heading.h5 a').click(function(e){
    e.preventDefault();
  });
  

  $('.product-item-keg .card__inner').click(function(){
    var x = $(this).parent().find('a').attr('href');
    // location.href = ''+x+'';
  });


  

  /* keg ends */

  


  function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      vars[key] = value;
    });
    return vars;
  }

  function getUrlVars2() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      vars[key] = value;
    });
    return vars;
  }

  var test = getUrlVars()["test"];

  if (test == '1') {
    $('.product__info-container .product-form').addClass('testing');
  }

 



  


  if($("#ProductAccordion-6525cabc-ac9a-4d82-ab70-582f2f65d968-template--16334662271220__main" + name).length == 0) {
    setTimeout(function(){
    $('.sharethis-inline-share-buttons').appendTo('#ProductAccordion-6525cabc-ac9a-4d82-ab70-582f2f65d968-template--16334662369524__main');
       }, 500);
  } else {
    setTimeout(function(){
    $('.sharethis-inline-share-buttons').appendTo('#ProductAccordion-6525cabc-ac9a-4d82-ab70-582f2f65d968-template--16334662271220__main');
    }, 500);
  }


    
   

  
  function setDesktop() {
    console.log('for desktop');
  }

  function setMobile() {

  $('#shopify-section-template--15372227248334__1655499880813c9c8b .col-4 .caption').appendTo('#shopify-section-template--15372227248334__1655500123ff6b7d7c .pls-row');

    
    console.log('for mobile');

  $('.artist-info').insertAfter(".grid-title");
    

    $('#add-99cents').click(function(e){
      e.preventDefault();
      $('#quick-add-template--15372914557134__product-grid7026606801102-submit').click();
    });

    $('#buy-99cents').click(function(e){
      e.preventDefault();
      $('#item4 .shopify-payment-button__button').click();
    });

  
    // $('.header__heading-link').html('<svg xmlns="http://www.w3.org/2000/svg" width="29.869" height="32.15" viewBox="0 0 29.869 32.15"> <g id="Group_820" data-name="Group 820" transform="translate(0 -0.286)" style="isolation: isolate"> <path id="Path_269" data-name="Path 269" d="M13.085,14.805c-2.889,0-9.745.022-10.6.022A2.716,2.716,0,0,0,0,17.628V43.185a1.77,1.77,0,0,0,1.77,1.77h.7a1.77,1.77,0,0,0,1.77-1.77V36.692a2.884,2.884,0,0,1,2.891-2.884c2,.006,4,.022,5.951.023,4.983.042,9.035-3.632,9.035-9.509s-4.049-9.558-9.035-9.516m-.233,15.348H7.126a2.946,2.946,0,0,1-2.884-3.235V21.708a3.174,3.174,0,0,1,3.176-3.174l5.434,0c3,0,5.028,2.471,5.028,5.784s-2.021,5.832-5.027,5.832" transform="translate(0 -12.519)"/> <g id="Group_821" data-name="Group 821" transform="translate(24.786 0.286)"> <path id="Path_270" data-name="Path 270" d="M1097.408,164.7h-.106a2.489,2.489,0,0,0-2.489,2.489v.106a2.489,2.489,0,0,0,2.489,2.489h.106a2.489,2.489,0,0,0,2.489-2.489v-.106a2.489,2.489,0,0,0-2.489-2.489" transform="translate(-1094.813 -137.77)"/> <path id="Path_271" data-name="Path 271" d="M1096.792,20.354a1.211,1.211,0,1,0,2.42,0c.3-3.635.952-13.623,1.178-17.268.022-.362.027-.622.027-.755A2.4,2.4,0,0,0,1098,0a2.327,2.327,0,0,0-2.415,2.331c0,.133,0,.369.023.689.258,4,.877,13.66,1.182,17.334" transform="translate(-1095.46 -0.001)"/> </g> </g> </svg>');

    $('.header__heading-link').html('<svg xmlns="http://www.w3.org/2000/svg" width="105.436" height="108" viewBox="0 0 105.436 108"> <g id="Group_574" data-name="Group 574" transform="translate(0 0)"> <path id="Path_230" data-name="Path 230" d="M112.917,94.106l6.264-4.6a.853.853,0,0,0,.182-1.192l-.117-.16a.853.853,0,0,0-1.192-.182L113.6,91.243a1.5,1.5,0,0,1-2.1-.321l-6.546-8.9a.908.908,0,0,0-1.27-.194l-.28.206a.908.908,0,0,0-.194,1.27l7.721,10.5a1.424,1.424,0,0,0,1.99.3" transform="translate(-87.591 -69.413)" fill="#050605"/> <path id="Path_231" data-name="Path 231" d="M207.451,23.552l8.108-2.542a.849.849,0,0,0,.556-1.064l-.062-.2a.849.849,0,0,0-1.064-.556l-6.2,1.945a1.387,1.387,0,0,1-1.738-.908l-.589-1.878a1.623,1.623,0,0,1,1.063-2.034l3.919-1.229A.851.851,0,0,0,212,14.022l-.061-.193a.851.851,0,0,0-1.066-.557l-4.006,1.256a1.532,1.532,0,0,1-1.92-1l-.53-1.691a1.386,1.386,0,0,1,.908-1.738l5.725-1.8a.851.851,0,0,0,.557-1.066l-.06-.192a.851.851,0,0,0-1.068-.557L202.7,8.933a1.4,1.4,0,0,0-.915,1.754L205.5,22.534a1.554,1.554,0,0,0,1.948,1.018" transform="translate(-171.497 -5.479)" fill="#050605"/> <path id="Path_232" data-name="Path 232" d="M514.73,99.21,510.1,94.415a1.224,1.224,0,0,1,.031-1.731l1.418-1.368a1.783,1.783,0,0,1,2.521.045l2.741,2.84a.851.851,0,0,0,1.2.021l.146-.14a.851.851,0,0,0,.021-1.2l-2.8-2.906a1.692,1.692,0,0,1,.043-2.393l1.1-1.059a1.474,1.474,0,0,1,2.085.037l4.106,4.254a.851.851,0,0,0,1.2.021l.145-.14a.851.851,0,0,0,.021-1.2l-5.57-5.757a1.541,1.541,0,0,0-2.178-.037l-8.842,8.532a1.541,1.541,0,0,0-.039,2.179l5.91,6.124a.849.849,0,0,0,1.2.021l.148-.143a.849.849,0,0,0,.021-1.2" transform="translate(-431.044 -70.787)" fill="#050605"/> <path id="Path_233" data-name="Path 233" d="M324.448,12.317l.8,2.669a1.093,1.093,0,0,0,.97.778l.529.037a.675.675,0,0,0,.693-.87L323.159.9a1.179,1.179,0,0,0-1.044-.832L321.189,0a1.179,1.179,0,0,0-1.151.677l-6.21,13.29a.675.675,0,0,0,.564.959l.529.037a1.093,1.093,0,0,0,1.07-.633l1.164-2.531A1.987,1.987,0,0,1,319.1,10.65l3.584.253a1.987,1.987,0,0,1,1.764,1.413m-2.5-3.374-1.85-.131a1.055,1.055,0,0,1-.884-1.493L320.9,3.67a.532.532,0,0,1,.992.07l1.148,3.848a1.055,1.055,0,0,1-1.085,1.354" transform="translate(-266.748 0)" fill="#050605"/> <path id="Path_234" data-name="Path 234" d="M33.182,129.441c-.824,1.221-2.775,4.124-3.019,4.484a1.386,1.386,0,0,0,.472,1.852l10.8,7.3a.9.9,0,0,0,1.254-.242l.2-.3a.9.9,0,0,0-.242-1.254L39.9,139.431a1.471,1.471,0,0,1-.392-2.046c.574-.844,1.153-1.685,1.71-2.508a4.534,4.534,0,0,0-1.436-6.535,4.536,4.536,0,0,0-6.6,1.1m6.418,4.484-1.636,2.419a1.5,1.5,0,0,1-2.191.294l-2.2-1.489a1.619,1.619,0,0,1-.433-2.249l1.555-2.3a2.669,2.669,0,0,1,3.88-.472,2.69,2.69,0,0,1,1.027,3.791" transform="translate(-25.488 -108.303)" fill="#050605"/> <path id="Path_235" data-name="Path 235" d="M567.467,214.7l-.028-.046a1.269,1.269,0,0,0-1.744-.424l-.046.028a1.269,1.269,0,0,0-.424,1.744l.028.046a1.27,1.27,0,0,0,1.745.424l.046-.028a1.269,1.269,0,0,0,.424-1.744" transform="translate(-480.37 -181.97)" fill="#050605"/> <path id="Path_236" data-name="Path 236" d="M596.361,172a.618.618,0,1,0,.642,1.054c1.664-.832,6.188-3.2,7.836-4.066.164-.086.278-.153.336-.188a1.226,1.226,0,0,0,.375-1.67,1.187,1.187,0,0,0-1.656-.434c-.058.035-.16.1-.294.193-1.673,1.172-5.72,4-7.239,5.112" transform="translate(-506.731 -141.567)" fill="#050605"/> <path id="Path_237" data-name="Path 237" d="M434.867,32.811a11.975,11.975,0,0,0-3.116-2.556,8.5,8.5,0,0,1-2.5-2.041,1.792,1.792,0,0,1-.065-1.776c.553-1.192,2.166-1.51,4.157-.585a3.416,3.416,0,0,1,2.313,3.765,1.223,1.223,0,0,0,.977,1.289l.095.019a.948.948,0,0,0,1.1-.856c.307-1.929-.263-4.466-3.5-5.971a6.643,6.643,0,0,0-4.227-.7,3.962,3.962,0,0,0-2.873,2.124,3.616,3.616,0,0,0,.393,4.135,12.266,12.266,0,0,0,3.01,2.4,8.667,8.667,0,0,1,2.415,2,1.721,1.721,0,0,1,.1,1.826c-.642,1.383-2.512,1.784-4.534.846a4.453,4.453,0,0,1-2.333-2.04,3.472,3.472,0,0,1-.181-1.949,1.17,1.17,0,0,0-.9-1.314l-.106-.028a.991.991,0,0,0-1.2.778,4.984,4.984,0,0,0,.347,3.4,6.943,6.943,0,0,0,3.528,2.967,6.586,6.586,0,0,0,4.481.605,4.4,4.4,0,0,0,2.914-2.466,3.567,3.567,0,0,0-.288-3.873" transform="translate(-360.242 -19.8)" fill="#050605"/> <path id="Path_238" data-name="Path 238" d="M.033,311.639c-.289,2.766,1.281,5.362,5.344,5.786s6.136-1.791,6.425-4.557-1.308-5.365-5.344-5.787S.323,308.873.033,311.639m9.787,1.023c-.194,1.862-2.006,3.013-4.235,2.78s-3.768-1.694-3.569-3.6c.195-1.862,2.026-3.011,4.235-2.78s3.768,1.694,3.569,3.6" transform="translate(0 -261.023)" fill="#050605"/> <path id="Path_239" data-name="Path 239" d="M16.113,401.832a4.85,4.85,0,0,0-3.408-3.741.948.948,0,0,0-1.157.621l-.04.123a1.023,1.023,0,0,0,.654,1.285,2.955,2.955,0,0,1,2.01,2.162c.422,1.823-.916,3.5-3.1,4.008s-4.114-.376-4.545-2.238a2.972,2.972,0,0,1,.866-2.821,1.023,1.023,0,0,0,.019-1.438l-.1-.1A.948.948,0,0,0,6,399.642,4.851,4.851,0,0,0,4.585,404.5c.627,2.71,2.957,4.653,6.937,3.731s5.219-3.691,4.591-6.4" transform="translate(-3.768 -338.408)" fill="#050605"/> <path id="Path_240" data-name="Path 240" d="M251.661,618.19l-.423-2.594a1.031,1.031,0,0,0-.814-.845l-.491-.1a.637.637,0,0,0-.754.73l2.309,13.649a1.112,1.112,0,0,0,.877.9l.858.173a1.112,1.112,0,0,0,1.159-.494l7.417-11.688a.637.637,0,0,0-.412-.965l-.491-.1a1.031,1.031,0,0,0-1.078.464l-1.4,2.228a1.875,1.875,0,0,1-1.959.843l-3.324-.67a1.875,1.875,0,0,1-1.48-1.536m1.928,3.459,1.716.346a1,1,0,0,1,.647,1.5l-2.012,3.212a.5.5,0,0,1-.92-.186l-.61-3.741a1,1,0,0,1,1.179-1.136" transform="translate(-211.833 -522.538)" fill="#050605"/> <path id="Path_241" data-name="Path 241" d="M457.728,580.65l5.206-3.506a1.153,1.153,0,0,1,1.6.312L465.571,579a1.679,1.679,0,0,1-.455,2.331l-3.084,2.077a.8.8,0,0,0-.217,1.112l.106.158a.8.8,0,0,0,1.112.217l3.155-2.125a1.594,1.594,0,0,1,2.212.432l.8,1.191a1.389,1.389,0,0,1-.376,1.927l-4.619,3.111a.8.8,0,0,0-.217,1.112l.106.157a.8.8,0,0,0,1.113.217l6.252-4.223a1.451,1.451,0,0,0,.392-2.014l-6.465-9.6a1.452,1.452,0,0,0-2.015-.393l-6.649,4.478a.8.8,0,0,0-.216,1.11l.108.161a.8.8,0,0,0,1.11.217" transform="translate(-387.987 -488.36)" fill="#050605"/> <path id="Path_242" data-name="Path 242" d="M584.067,434.177l1.795-6.014a1.153,1.153,0,0,1,1.435-.775l1.779.531a1.679,1.679,0,0,1,1.129,2.09l-1.063,3.563a.8.8,0,0,0,.539,1l.183.055a.8.8,0,0,0,1-.539l1.088-3.645a1.594,1.594,0,0,1,1.983-1.072l1.376.411a1.389,1.389,0,0,1,.934,1.728l-1.593,5.336a.8.8,0,0,0,.539,1l.182.054a.8.8,0,0,0,1-.54l2.148-7.232a1.452,1.452,0,0,0-.976-1.8l-11.09-3.309a1.452,1.452,0,0,0-1.806.976l-2.292,7.681a.8.8,0,0,0,.538.995l.186.055a.8.8,0,0,0,.995-.537" transform="translate(-495.057 -361.27)" fill="#050605"/> <path id="Path_243" data-name="Path 243" d="M40.875,493.1l3.577,5.157a1.153,1.153,0,0,1-.29,1.6l-1.525,1.058A1.68,1.68,0,0,1,40.3,500.5l-2.119-3.055a.8.8,0,0,0-1.115-.2l-.156.108a.8.8,0,0,0-.2,1.115l2.168,3.126a1.594,1.594,0,0,1-.4,2.218l-1.18.818a1.389,1.389,0,0,1-1.932-.35L32.187,499.7a.8.8,0,0,0-1.115-.2l-.156.108a.8.8,0,0,0-.2,1.116l4.308,6.194a1.452,1.452,0,0,0,2.019.364l9.51-6.6a1.452,1.452,0,0,0,.365-2.02l-4.568-6.587a.8.8,0,0,0-1.113-.2l-.159.111a.8.8,0,0,0-.2,1.113" transform="translate(-25.99 -418.05)" fill="#050605"/> <path id="Path_244" data-name="Path 244" d="M613.7,319.131a3.559,3.559,0,0,0,1.928.4,3.752,3.752,0,0,0,3.528-4.3c-.146-1.6-.3-3.173-.4-4.764h-.012A1.661,1.661,0,0,0,616.962,309l-10.913.909a1.905,1.905,0,0,0-1.741,2.057l.012.138c.087,1.043.273,3.255.431,5.155a3.971,3.971,0,0,0,4.28,3.526,4.014,4.014,0,0,0,2.638-1.249,1.728,1.728,0,0,1,2.036-.4m1.68-7.954a1.583,1.583,0,0,1,1.709,1.448c.072.879.14,1.714.225,2.736a2.057,2.057,0,0,1-2.092,2.149c-1.44.12-2.266-1.158-2.4-2.7l-.144-1.722a1.677,1.677,0,0,1,1.532-1.811Zm-8.864,5.246c-.09-1.075-.182-2.084-.266-3.087a1.393,1.393,0,0,1,1.272-1.5l1.314-.11a1.962,1.962,0,0,1,2.119,1.8c.071.892.138,1.744.171,2.139.165,1.979-.8,2.92-1.986,3.019a2.234,2.234,0,0,1-2.624-2.257" transform="translate(-513.749 -262.688)" fill="#050605"/> <path id="Path_245" data-name="Path 245" d="M130.05,583.616l2.808,1.935a.815.815,0,0,0,1.134-.209l.079-.115a.816.816,0,0,0-.209-1.134l-.878-.6a1.121,1.121,0,0,1,.229-2.017,4.174,4.174,0,0,1,3.779.623c2.229,1.536,2.437,4.633.6,7.3s-4.759,3.61-7.035,2.042a4.356,4.356,0,0,1-1.8-4.2,1.142,1.142,0,0,0-.8-1.219l-.113-.035a.838.838,0,0,0-1.068.659,6.123,6.123,0,0,0,2.747,6.288c2.9,2,6.733,1.824,9.666-2.432s1.727-7.9-1.171-9.9c-2.419-1.666-5.63-1.89-8.015.721-.075.082-.154.173-.234.27a1.383,1.383,0,0,0,.278,2.025" transform="translate(-107.693 -492.538)" fill="#050605"/> <path id="Path_246" data-name="Path 246" d="M557.138,535.921l.3-.4a1.03,1.03,0,0,0,.048-1.17l-.76-1.2-3.48-5.5-1.669-2.639a.5.5,0,0,1,.564-.748l3,.88,6.177,1.814,1.434.421a1.03,1.03,0,0,0,1.112-.368l.3-.4a.635.635,0,0,0-.332-.993l-13.28-3.814a1.11,1.11,0,0,0-1.193.4l-.526.7a1.11,1.11,0,0,0-.055,1.256l7.317,11.721a.635.635,0,0,0,1.046.046" transform="translate(-466.4 -443.575)" fill="#050605"/> <path id="Path_247" data-name="Path 247" d="M359.362,621.628l.266,1.218a4.17,4.17,0,0,0,1.1,2.131,1.485,1.485,0,0,1,.29,1.543,4.068,4.068,0,0,0-.161,2.662,3.9,3.9,0,0,0,4.6,3.064c1.227-.271,3.808-.849,5.034-1.1l0-.01a1.89,1.89,0,0,0,1.34-2.224l-2.506-11.458a.948.948,0,0,0-1.31-.633.9.9,0,0,0-.686,1.07l.78,3.568a1.487,1.487,0,0,1-1.142,1.772c-.626.133-1.744.372-2.9.624a1.787,1.787,0,0,1-2.433-1.454l-.266-1.218a5.307,5.307,0,0,0-.909-1.991,1.171,1.171,0,0,0-1.2-.457l-.385.084a.734.734,0,0,0-.391,1.207,3.559,3.559,0,0,1,.872,1.6m9.77,4.511.357,1.633a1.69,1.69,0,0,1-1.288,2.011c-.418.1-2.505.552-2.706.6a2.23,2.23,0,0,1-2.618-1.717c-.02-.094-.06-.269-.078-.359a2.268,2.268,0,0,1,1.615-2.639c.1-.029.372-.079.475-.108q1.233-.28,2.467-.553a1.489,1.489,0,0,1,1.775,1.135" transform="translate(-304.612 -524.339)" fill="#050605"/> </g> </svg>');
    $('.footer__blocks-wrapper').append('<div class="footer-block footer-block--menu mobile-add"></div>');
    $('.footer__legal .page-width .col-6, .newsletter-wrap > svg').appendTo('.mobile-add');
    $('.footer__legal .page-width div:nth-child(2)').appendTo('.footer__blocks-wrapper > div:nth-child(2)');

    $(".footer__legal .col-3").each(function() {
        var str = $(this).html();
        str = str.replace("LTD.", "LTD.<br/>");
        $(this).html(str);
    });

    /* clone footer */
    $(function(){
      var $footer = $('#shopify-section-footer .footer').clone();
      $('.mobile-drawer').append($footer);
    });


    
  }

  
  var windowW = $(window).width();
  var desktopMode = true;
  var mobileMode = false;

  function calibratePls() {
  
    if (windowW > 768) {
 
      if (!desktopMode) {
        setDesktop();
        desktopMode = true;
      }
      
    } else {

      if (!mobileMode) {
        setMobile();
        mobileMode = true;
      }
      
    }
  }
  
  calibratePls();
  
  $(window).resize(function(){
    windowW = $(window).width();
    calibratePls();
  });


  var mobileMenu = false;
  $('#mobile-menu').click(function(e){
    e.preventDefault();
    if (!mobileMenu) {
      $(this).addClass('open');
      $('.mobile-drawer-wrap').addClass('open');
      $('#shopify-section-header').addClass('mobile-menu-open');
      mobileMenu =  true;
    } else {
      $(this).removeClass('open');
      $('.mobile-drawer-wrap').removeClass('open');
      $('#shopify-section-header').removeClass('mobile-menu-open');
      mobileMenu = false;
    }
    
    
  });
  
  setTimeout(function(){
    $('.shopify-payment-button__button--unbranded').html('Buy Now');
  
    setTimeout(function(){
      $('body').addClass('is-loaded');
    }, 200);
    
  }, 800);

  

   $('#parallax').parallax();
  
  
  $('.block-newsletter h3').click(function(e){
    e.preventDefault();
    $('.block-newsletter').addClass('open');
  });
  
  $('.close-newsletter').click(function(e){
    e.preventDefault();
     $('.block-newsletter').removeClass('open'); 
  });
    

  /* product grid*/
  
  $('.product-item-cocktails .card__inner').click(function(){
    var x = $(this).parent().find('a').attr('href');
    location.href = ''+x+'';
  });
  
  
  
  $('.product-item-cocktails .card--media').mouseover(function(){
   $(this).find('video').get(0).play();
    // console.log('enter');
    }).mouseout(function(){
    // console.log('leave');

    $(this).find('video').get(0).pause();
    // $(this).find('video').get(0).currentTime = 0;


  });

      
      
  $('.quick-add-to-cart').click(function(e){
    e.preventDefault();
    $(this).parent('.cocktail-btn-group').find('input[type=submit]').click();
  });
  
  

  function scrollLock() {
	var scrollPosition = [
		self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
		self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
	];

	var html = jQuery('html'); // it would make more sense to apply this to body, but IE7 won't have that
	html.data('scroll-position', scrollPosition);
	html.data('previous-overflow', html.css('overflow'));
	html.css('overflow', 'hidden');
	window.scrollTo(scrollPosition[0], scrollPosition[1]);
	}

	function scrollUnlock() {
		// un-lock scroll position
		var html = jQuery('html');
		var scrollPosition = html.data('scroll-position');
		html.css('overflow', html.data('previous-overflow'));
		window.scrollTo(scrollPosition[0], scrollPosition[1])
	}

  function openVid() {
    $('.block-video-popup-wrapper').addClass('on');
    $('#pleasevid').get(0).play();
  }

   


  function readCookie() {

    if($('body').hasClass('page-template-index')) {

        $('.block-video-popup-wrapper').addClass('on');


        if ( Cookies.get('please-age-gate')) {
      
          /* with cookie */
          // $('.popup__content video')[0].play();
          $('.block-age-gate').addClass('on');
          scrollLock();
      
        } else {
          
          $('.block-age-gate').addClass('on');
          scrollLock();
          
        }
    } else {
      if ( Cookies.get('please-age-gate')) {
      
        /* with cookie */
        // $('.popup__content video')[0].play();
    
      } else {
        
        $('.block-age-gate').addClass('on');
        scrollLock();
        
      }
    }
  
  }
  
  
  readCookie();

  $('#age-gate-yes').click(function(e){
    e.preventDefault();

    //$('.block-video-popup video')[0].play();

    Cookies.set('please-age-gate', 'yes', { expires: 1 });

    $('.block-age-gate').addClass('exit');
    $('.popup__content video')[0].play();

    
    scrollUnlock();
  });


  
  $('.btn__close-popup').click(function(){
      
    $('.block-video-popup-wrapper').removeClass('on');
    $('.popup__content video')[0].pause();
    scrollUnlock();
    
    return false;

  });

  

 
  var cocktailClubSlider = $('#cocktail-club-slider').bxSlider({
      speed: 500,
      controls: false,
      minSlides: 1,
      maxSlides: 3,
      slideWidth: 800,
      auto: true,
      pager: true
  
  });
  
  
   var plsSlider = $('.pls-img-slider').bxSlider({
      mode: "fade",
     auto: true,
      speed: 800,
      controls: false,
     pager: true
     
  });
    

    var ingSlider = $('.ingredient-slider-single').bxSlider({
      mode: "fade",
      speed: 200,
      controls: false
  });
  
  $('.pls-ingredients-single ul').each(function(){
     
      
      var x = $(this).find('li').length;

//       $(this).find('li').append(',');


//       var y = $(this).find("li:nth-child(4)").html().replace(/,/g, '.');
//       $(this).find("li:nth-child(4)").html('& '+y);


      for (let i = 0; i < x+1; i++) {
          $(this).find("li:nth-child("+ i +")").find('a').attr("data-ingredients",i);
      }
     
     
     $(this).find('a').click(function(x){
       x.preventDefault();
       
     }).on('mouseover',function(e){

      	var z = $(this).attr('data-ingredients');

      	$(this).parents('ul').find('a').removeClass('active');
      	$(this).addClass('active');
       
       
//        ingSlider.goToSlide(z);
//        console.log('go to slide'+z);
       
       var y = (z-1);
       
         $('[data-slide-index='+y+']').click();
        
    });

 
//   	$(this).find('a').on('click',function(e){
//       e.preventDefault();
//     });
  

  });
   
  
  var mixEmmaJean = $('#rhubarb-fizz').bxSlider({
    mode: "fade",
    speed: 200,
    controls: false,
  
  });
  
  var mixCents99 = $('#green-tea-fizz').bxSlider({
    mode: "fade",
    speed: 200,
    controls: false,
  
  });
  
  var mixThirdBeach = $('#mango-coconut-pandan').bxSlider({
    mode: "fade",
    speed: 200,
    controls: false,
  
  });
  
  var mixGfp = $('#grapefruit-paloma').bxSlider({
    mode: "fade",
    speed: 200,
    controls: false,
  
  });

  var mixCanRaspberry = $('#raspberry-juniper-mint').bxSlider({
    mode: "fade",
    speed: 200,
    controls: false,
  
  });

    var mixCanPassionfruit = $('#passionfruit-ginger-calamansi').bxSlider({
    mode: "fade",
    speed: 200,
    controls: false,
  
  });


   var mixCanMango = $('#mango-coconut-pandan').bxSlider({
    mode: "fade",
    speed: 200,
    controls: false,
  
  });


 



 


  
  
     $('.pls-ingredients-mix ul').each(function(){
     
        var dontshow;
        var x = $(this).find('li').length;
        var m = 0;

        for (let i = 0; i < x+1; i++) {
            $(this).find("li:nth-child("+ i +")").find('a').attr("data-ingredients",i);
        }

       $(this).find('a').click(function(x){
         x.preventDefault();
         

       }).on('mouseover',function(){
         
          dontshow = true;
          var z = $(this).attr('data-ingredients');

          $(this).parents('ul').find('a').removeClass('active');
          $(this).addClass('active');
          var y = (z-0);

           $(this).parents('.pls-ingredients-mix').find('a[data-slide-index='+y+']').click();

      }).on('mouseleave',function(e){

              dontshow = false;
              $(this).parents('ul').find('a').removeClass('active');
              $(this).removeClass('active');

          
             setTimeout(function(){
              if (!dontshow) {
                
               }
             }, 1000);


  
 
       });
 
       
       

  	});
      
  
  


  
  
 
  


  if ($('body').is('.page-template-product, .page-template-product\\.mix-pack')){

     if($('body').is('.page-template-product')){
        $('variant-radios').wrap('<div class="wrap-quantity"></div>');
        $('.product-form__quantity').appendTo('.wrap-quantity');
     } else {
       $('.quantity').wrap('<div class="wrap-quantity"></div>');
       $('#price-template--16334662369524__main').prependTo('.wrap-quantity');
     }
  

    var moved = false;
    
    var marqueeLoc = $('.marquee-block').offset().top;
    var conHeight = $('.product-form').height();
    var buttonHeight = $('.product-form__buttons').height();
    
    var vH = $(window).height();
    // console.log(marqueeLoc);

    
    $('.product-form').css('min-height',conHeight);
  


    if (vW > 768) {
      $(window).scroll(function(){
  
        var buttonLoc = $('.product-form').offset().top;
        var y = $(document).scrollTop();
  
         if ((y > (buttonLoc + buttonHeight)) && (y < (marqueeLoc - (vH*0.6) ))) {
           if(moved) { 
             
           } else {
              $('#product-form-template--15372088279246__main, #product-form-template--15373753090254__main').appendTo('.sticky-buttons');
  
             setTimeout(function(){
               $('.sticky-buttons').fadeIn(400);
             }, 100); 
             moved = true;
           }
             
         } else {
           
          if(moved) {          
            $('.sticky-buttons').fadeOut(400);
            setTimeout(function(){
             $('#product-form-template--15372088279246__main, #product-form-template--15373753090254__main').appendTo('.product-form');
           }, 400);
            
            moved = false;
    
          }
         }  
     });  /* end window scroll */

    } else {

      /* remove this temp 
      $('#product-form-template--15372088279246__main, #product-form-template--15373753090254__main').appendTo('.sticky-buttons');

*/
  
       setTimeout(function(){
         $('.sticky-buttons').fadeIn(200);
       }, 100);

       $(window).scroll(function(){
         var y = $(document).scrollTop();

         if (y > (marqueeLoc - vH)) {
             $('.sticky-buttons').fadeOut(200);
         } else {
            $('.sticky-buttons').fadeIn(200);
         }
         
       });


    
    }

    

  } else {
    
    $(window).scroll(function(){
  
    var py = $(document).scrollTop();
    var ph = $(window).height();
    var pz = py/ph*20;
    var pq = (100 + pz);

      if ( $(window).width() < 768) {
      var pz = py/ph*100;
      
        var pq = (320 + pz);
      } else {
         var pq = (100 + pz);
      }

      var pm = (1 + (pz/120));

      // console.log(pm);

/*
     $('.please-banner-image').css({
       'background-size':''+ pq +'%'
     });
     */

      $('.please-banner-image .banner').css({

        'transform'         : 'scale(' + pm + ')'
     });

   });
  }
    
  
    
if ($('body').hasClass('page-template-index')) {


    $(window).scroll(function(){
      

    $.fn.preload = function() {
      this.each(function(){
        $('<img/>')[0].src = this;
      });
    }

    var assetUrl = 'https://cdn.shopify.com/s/files/1/0629/8409/3940/files/';
     // Usage:
    $([
          assetUrl+"Please-000.png",
          assetUrl+"Please-001.png",
          assetUrl+"Please-002.png",
          assetUrl+"Please-003.png",
          assetUrl+"Please-004.png",
          assetUrl+"Please-005.png",
          assetUrl+"Please-006.png",
          assetUrl+"Please-007.png",
          assetUrl+"Please-008.png",
          assetUrl+"Please-009.png",
          assetUrl+"Please-010.png",
          assetUrl+"Please-011.png",
          assetUrl+"Please-012.png",
          assetUrl+"Please-013.png",
          assetUrl+"Please-014.png",
          assetUrl+"Please-015.png",
          assetUrl+"Please-016.png",
          assetUrl+"Please-017.png",
          assetUrl+"Please-018.png",
          assetUrl+"Please-019.png",
          assetUrl+"Please-020.png",
          assetUrl+"Please-021.png",
          assetUrl+"Please-022.png",
          assetUrl+"Please-023.png",
          assetUrl+"Please-024.png",
          assetUrl+"Please-025.png",
          assetUrl+"Please-026.png",
          assetUrl+"Please-027.png",
          assetUrl+"Please-028.png",
          assetUrl+"Please-029.png",
          assetUrl+"Please-030.png",
          assetUrl+"Please-031.png",
          assetUrl+"Please-032.png",
          assetUrl+"Please-033.png",
          assetUrl+"Please-034.png",
          assetUrl+"Please-035.png",
          assetUrl+"Please-036.png",
          assetUrl+"Please-037.png",
          assetUrl+"Please-038.png",
          assetUrl+"Please-039.png",
          assetUrl+"Please-040.png",
          assetUrl+"Please-041.png",
          assetUrl+"Please-042.png",
          assetUrl+"Please-043.png",
          assetUrl+"Please-044.png",
          assetUrl+"Please-045.png",
          assetUrl+"Please-046.png",
          assetUrl+"Please-047.png",
          assetUrl+"Please-048.png",
          assetUrl+"Please-049.png",
          assetUrl+"Please-050.png",
          assetUrl+"Please-051.png",
          assetUrl+"Please-052.png",
          assetUrl+"Please-053.png",
          assetUrl+"Please-054.png",
          assetUrl+"Please-055.png",
          assetUrl+"Please-056.png",
          assetUrl+"Please-057.png",
          assetUrl+"Please-058.png",
          assetUrl+"Please-059.png",
          assetUrl+"Please-060.png",
          assetUrl+"Please-061.png",
          assetUrl+"Please-062.png",
          assetUrl+"Please-063.png",
          assetUrl+"Please-064.png",
          assetUrl+"Please-065.png",
          assetUrl+"Please-066.png",
          assetUrl+"Please-067.png",
          assetUrl+"Please-068.png",
          assetUrl+"Please-069.png",
          assetUrl+"Please-070.png",
          assetUrl+"Please-071.png",
          assetUrl+"Please-072.png",
          assetUrl+"Please-073.png",
          assetUrl+"Please-074.png",
          assetUrl+"Please-075.png",
          assetUrl+"Please-076.png",
          assetUrl+"Please-077.png",
          assetUrl+"Please-078.png",
          assetUrl+"Please-079.png",
          assetUrl+"Please-080.png",
          assetUrl+"Please-081.png",
          assetUrl+"Please-082.png",
          assetUrl+"Please-083.png",
          assetUrl+"Please-084.png",
          assetUrl+"Please-085.png",
          assetUrl+"Please-086.png",
          assetUrl+"Please-087.png",
          assetUrl+"Please-088.png",
          assetUrl+"Please-089.png",
          assetUrl+"Please-090.png",
          assetUrl+"Please-091.png",
          assetUrl+"Please-092.png",
          assetUrl+"Please-093.png",
          assetUrl+"Please-094.png",
          assetUrl+"Please-095.png",
          assetUrl+"Please-096.png",
          assetUrl+"Please-097.png",
          assetUrl+"Please-098.png",
          assetUrl+"Please-099.png",
          assetUrl+"Please-100.png",
          assetUrl+"Please-101.png",
          assetUrl+"Please-102.png",
          assetUrl+"Please-103.png",
          assetUrl+"Please-104.png",
          assetUrl+"Please-105.png",
          assetUrl+"Please-106.png",
          assetUrl+"Please-107.png",
          assetUrl+"Please-108.png",
          assetUrl+"Please-109.png",
          assetUrl+"Please-110.png",
          assetUrl+"Please-111.png",
          assetUrl+"Please-112.png",
          assetUrl+"Please-113.png",
          assetUrl+"Please-114.png",
          assetUrl+"Please-115.png",
          assetUrl+"Please-116.png",
          assetUrl+"Please-117.png",
          assetUrl+"Please-118.png",
          assetUrl+"Please-119.png",
          assetUrl+"Please-120.png",
          assetUrl+"Please-121.png",
          assetUrl+"Please-122.png",
          assetUrl+"Please-123.png",
          assetUrl+"Please-124.png",
          assetUrl+"Please-125.png",
          assetUrl+"Please-126.png",
          assetUrl+"Please-127.png",
          assetUrl+"Please-128.png",
          assetUrl+"Please-129.png",
          assetUrl+"Please-130.png",
          assetUrl+"Please-131.png",
          assetUrl+"Please-132.png",
          assetUrl+"Please-133.png",
          assetUrl+"Please-134.png",
          assetUrl+"Please-135.png",
          assetUrl+"Please-136.png",
          assetUrl+"Please-137.png",
          assetUrl+"Please-138.png",
          assetUrl+"Please-139.png",
          assetUrl+"Please-140.png",
          assetUrl+"Please-141.png",
          assetUrl+"Please-142.png",
          assetUrl+"Please-143.png",
          assetUrl+"Please-144.png",
          assetUrl+"Please-145.png",
          assetUrl+"Please-146.png",
          assetUrl+"Please-147.png",
          assetUrl+"Please-148.png",
          assetUrl+"Please-149.png",
          assetUrl+"Please-150.png",
          assetUrl+"Please-151.png",
          assetUrl+"Please-152.png",
          assetUrl+"Please-153.png",
          assetUrl+"Please-154.png",
          assetUrl+"Please-155.png",
          assetUrl+"Please-156.png",
          assetUrl+"Please-157.png",
          assetUrl+"Please-158.png",
          assetUrl+"Please-159.png",
          assetUrl+"Please-160.png",
          assetUrl+"Please-161.png",
          assetUrl+"Please-162.png",
          assetUrl+"Please-163.png",
          assetUrl+"Please-164.png",
          assetUrl+"Please-165.png",
          assetUrl+"Please-166.png",
          assetUrl+"Please-167.png",
          assetUrl+"Please-168.png",
          assetUrl+"Please-169.png",
          assetUrl+"Please-170.png",
          assetUrl+"Please-171.png",
          assetUrl+"Please-172.png",
          assetUrl+"Please-173.png",
          assetUrl+"Please-174.png",
          assetUrl+"Please-175.png",
          assetUrl+"Please-176.png",
          assetUrl+"Please-177.png",
          assetUrl+"Please-178.png",
          assetUrl+"Please-179.png",
          assetUrl+"Please-180.png",
          assetUrl+"Please-181.png",
          assetUrl+"Please-182.png",
          assetUrl+"Please-183.png",
          assetUrl+"Please-184.png",
          assetUrl+"Please-185.png",
          assetUrl+"Please-186.png",
          assetUrl+"Please-187.png",
          assetUrl+"Please-188.png",
          assetUrl+"Please-189.png",
          assetUrl+"Please-190.png",
          assetUrl+"Please-191.png",
          assetUrl+"Please-192.png",
          assetUrl+"Please-193.png",
          assetUrl+"Please-194.png",
          assetUrl+"Please-195.png",
          assetUrl+"Please-196.png",
          assetUrl+"Please-197.png",
          assetUrl+"Please-198.png",
          assetUrl+"Please-199.png",
          assetUrl+"Please-200.png",
          assetUrl+"Please-201.png",
          assetUrl+"Please-202.png",
          assetUrl+"Please-203.png",
          assetUrl+"Please-204.png",
          assetUrl+"Please-205.png",
          assetUrl+"Please-206.png",
          assetUrl+"Please-207.png",
          assetUrl+"Please-208.png",
          assetUrl+"Please-209.png",
          assetUrl+"Please-210.png",
          assetUrl+"Please-211.png",
          assetUrl+"Please-212.png",
          assetUrl+"Please-213.png",
          assetUrl+"Please-214.png"
  ]).preload();
    
   
    var images = [
          assetUrl+"Please-000.png",
          assetUrl+"Please-001.png",
          assetUrl+"Please-002.png",
          assetUrl+"Please-003.png",
          assetUrl+"Please-004.png",
          assetUrl+"Please-005.png",
          assetUrl+"Please-006.png",
          assetUrl+"Please-007.png",
          assetUrl+"Please-008.png",
          assetUrl+"Please-009.png",
          assetUrl+"Please-010.png",
          assetUrl+"Please-011.png",
          assetUrl+"Please-012.png",
          assetUrl+"Please-013.png",
          assetUrl+"Please-014.png",
          assetUrl+"Please-015.png",
          assetUrl+"Please-016.png",
          assetUrl+"Please-017.png",
          assetUrl+"Please-018.png",
          assetUrl+"Please-019.png",
          assetUrl+"Please-020.png",
          assetUrl+"Please-021.png",
          assetUrl+"Please-022.png",
          assetUrl+"Please-023.png",
          assetUrl+"Please-024.png",
          assetUrl+"Please-025.png",
          assetUrl+"Please-026.png",
          assetUrl+"Please-027.png",
          assetUrl+"Please-028.png",
          assetUrl+"Please-029.png",
          assetUrl+"Please-030.png",
          assetUrl+"Please-031.png",
          assetUrl+"Please-032.png",
          assetUrl+"Please-033.png",
          assetUrl+"Please-034.png",
          assetUrl+"Please-035.png",
          assetUrl+"Please-036.png",
          assetUrl+"Please-037.png",
          assetUrl+"Please-038.png",
          assetUrl+"Please-039.png",
          assetUrl+"Please-040.png",
          assetUrl+"Please-041.png",
          assetUrl+"Please-042.png",
          assetUrl+"Please-043.png",
          assetUrl+"Please-044.png",
          assetUrl+"Please-045.png",
          assetUrl+"Please-046.png",
          assetUrl+"Please-047.png",
          assetUrl+"Please-048.png",
          assetUrl+"Please-049.png",
          assetUrl+"Please-050.png",
          assetUrl+"Please-051.png",
          assetUrl+"Please-052.png",
          assetUrl+"Please-053.png",
          assetUrl+"Please-054.png",
          assetUrl+"Please-055.png",
          assetUrl+"Please-056.png",
          assetUrl+"Please-057.png",
          assetUrl+"Please-058.png",
          assetUrl+"Please-059.png",
          assetUrl+"Please-060.png",
          assetUrl+"Please-061.png",
          assetUrl+"Please-062.png",
          assetUrl+"Please-063.png",
          assetUrl+"Please-064.png",
          assetUrl+"Please-065.png",
          assetUrl+"Please-066.png",
          assetUrl+"Please-067.png",
          assetUrl+"Please-068.png",
          assetUrl+"Please-069.png",
          assetUrl+"Please-070.png",
          assetUrl+"Please-071.png",
          assetUrl+"Please-072.png",
          assetUrl+"Please-073.png",
          assetUrl+"Please-074.png",
          assetUrl+"Please-075.png",
          assetUrl+"Please-076.png",
          assetUrl+"Please-077.png",
          assetUrl+"Please-078.png",
          assetUrl+"Please-079.png",
          assetUrl+"Please-080.png",
          assetUrl+"Please-081.png",
          assetUrl+"Please-082.png",
          assetUrl+"Please-083.png",
          assetUrl+"Please-084.png",
          assetUrl+"Please-085.png",
          assetUrl+"Please-086.png",
          assetUrl+"Please-087.png",
          assetUrl+"Please-088.png",
          assetUrl+"Please-089.png",
          assetUrl+"Please-090.png",
          assetUrl+"Please-091.png",
          assetUrl+"Please-092.png",
          assetUrl+"Please-093.png",
          assetUrl+"Please-094.png",
          assetUrl+"Please-095.png",
          assetUrl+"Please-096.png",
          assetUrl+"Please-097.png",
          assetUrl+"Please-098.png",
          assetUrl+"Please-099.png",
          assetUrl+"Please-100.png",
          assetUrl+"Please-101.png",
          assetUrl+"Please-102.png",
          assetUrl+"Please-103.png",
          assetUrl+"Please-104.png",
          assetUrl+"Please-105.png",
          assetUrl+"Please-106.png",
          assetUrl+"Please-107.png",
          assetUrl+"Please-108.png",
          assetUrl+"Please-109.png",
          assetUrl+"Please-110.png",
          assetUrl+"Please-111.png",
          assetUrl+"Please-112.png",
          assetUrl+"Please-113.png",
          assetUrl+"Please-114.png",
          assetUrl+"Please-115.png",
          assetUrl+"Please-116.png",
          assetUrl+"Please-117.png",
          assetUrl+"Please-118.png",
          assetUrl+"Please-119.png",
          assetUrl+"Please-120.png",
          assetUrl+"Please-121.png",
          assetUrl+"Please-122.png",
          assetUrl+"Please-123.png",
          assetUrl+"Please-124.png",
          assetUrl+"Please-125.png",
          assetUrl+"Please-126.png",
          assetUrl+"Please-127.png",
          assetUrl+"Please-128.png",
          assetUrl+"Please-129.png",
          assetUrl+"Please-130.png",
          assetUrl+"Please-131.png",
          assetUrl+"Please-132.png",
          assetUrl+"Please-133.png",
          assetUrl+"Please-134.png",
          assetUrl+"Please-135.png",
          assetUrl+"Please-136.png",
          assetUrl+"Please-137.png",
          assetUrl+"Please-138.png",
          assetUrl+"Please-139.png",
          assetUrl+"Please-140.png",
          assetUrl+"Please-141.png",
          assetUrl+"Please-142.png",
          assetUrl+"Please-143.png",
          assetUrl+"Please-144.png",
          assetUrl+"Please-145.png",
          assetUrl+"Please-146.png",
          assetUrl+"Please-147.png",
          assetUrl+"Please-148.png",
          assetUrl+"Please-149.png",
          assetUrl+"Please-150.png",
          assetUrl+"Please-151.png",
          assetUrl+"Please-152.png",
          assetUrl+"Please-153.png",
          assetUrl+"Please-154.png",
          assetUrl+"Please-155.png",
          assetUrl+"Please-156.png",
          assetUrl+"Please-157.png",
          assetUrl+"Please-158.png",
          assetUrl+"Please-159.png",
          assetUrl+"Please-160.png",
          assetUrl+"Please-161.png",
          assetUrl+"Please-162.png",
          assetUrl+"Please-163.png",
          assetUrl+"Please-164.png",
          assetUrl+"Please-165.png",
          assetUrl+"Please-166.png",
          assetUrl+"Please-167.png",
          assetUrl+"Please-168.png",
          assetUrl+"Please-169.png",
          assetUrl+"Please-170.png",
          assetUrl+"Please-171.png",
          assetUrl+"Please-172.png",
          assetUrl+"Please-173.png",
          assetUrl+"Please-174.png",
          assetUrl+"Please-175.png",
          assetUrl+"Please-176.png",
          assetUrl+"Please-177.png",
          assetUrl+"Please-178.png",
          assetUrl+"Please-179.png",
          assetUrl+"Please-180.png",
          assetUrl+"Please-181.png",
          assetUrl+"Please-182.png",
          assetUrl+"Please-183.png",
          assetUrl+"Please-184.png",
          assetUrl+"Please-185.png",
          assetUrl+"Please-186.png",
          assetUrl+"Please-187.png",
          assetUrl+"Please-188.png",
          assetUrl+"Please-189.png",
          assetUrl+"Please-190.png",
          assetUrl+"Please-191.png",
          assetUrl+"Please-192.png",
          assetUrl+"Please-193.png",
          assetUrl+"Please-194.png",
          assetUrl+"Please-195.png",
          assetUrl+"Please-196.png",
          assetUrl+"Please-197.png",
          assetUrl+"Please-198.png",
          assetUrl+"Please-199.png",
          assetUrl+"Please-200.png",
          assetUrl+"Please-201.png",
          assetUrl+"Please-202.png",
          assetUrl+"Please-203.png",
          assetUrl+"Please-204.png",
          assetUrl+"Please-205.png",
          assetUrl+"Please-206.png",
          assetUrl+"Please-207.png",
          assetUrl+"Please-208.png",
          assetUrl+"Please-209.png",
          assetUrl+"Please-210.png",
          assetUrl+"Please-211.png",
          assetUrl+"Please-212.png",
          assetUrl+"Please-213.png",
          assetUrl+"Please-214.png"   
      ];

      var obj = {curImg: 0};

      var tween = TweenMax.to(obj, 1,
          {
              curImg: images.length - 1,  
              roundProps: "curImg",       
              repeat: 1,                  
              immediateRender: true,      
              ease: Linear.easeNone,      
              onUpdate: function () {
                $("#myimg").attr("src", images[obj.curImg]);
              }
          }
      );
   
   
       var pleaseDuration = 7800; //initiate as false
  
      var controller = new ScrollMagic.Controller();
      var scene = new ScrollMagic.Scene({
          triggerElement: "#prod1", 
          start: "top bottom",
          duration: pleaseDuration
        })
    .setTween(tween)
    .addTo(controller);
 });
  



    
    /* PAGINATION */
  	$(window).resize(function () {
  		checkScroll();
  	});

    var trigger1 = true;
    var trigger2 = true;
    var trigger3 = true;
    var trigger4 = true;
    var triggerEnter = true;
    var triggerExit = true;
  
	function checkScroll() {

      state0 = $('#shopify-section-footer').offset().top;
      prod1 = $('#prod1').offset().top;
      prod2 = $('#prod2').offset().top;
      prod3 = $('#prod3').offset().top;
      prod4 = $('#prod4').offset().top;
      // console.log(state0);

      var y = $(document).scrollTop()
      var vh = $(window).height();
      // console.log(y);

      if (y > (state0 - vh)) {
        $('.please-banner-image .button, .block-newsletter').addClass('exit');
      } else {
         $('.please-banner-image .button, .block-newsletter').removeClass('exit');
      }

      
       if ((y > (prod1 - (vh * 0.25))) && (y < (prod4 - (vh * 0.25)))) {
        $('#imagesequence').addClass('enter');
       } else {
         $('#imagesequence').removeClass('enter');
       }

    

      
      if (y > (prod1 - (vh * 0.7)) && y < (prod1 + $('#prod1').height()) - (vh * 0.7)) {
	
           if (trigger1) {
             
              $('#cocktail-switcher .info').removeClass('enter').addClass('exit');

              console.log('drink 1');

            
              $('#info-emma-jean, #prod-text-1').addClass('enter');
          
    
              trigger1 = false;
          }
                
          trigger2 = true;
          trigger3 = true;
          trigger4 = true;
        
		}
		else if (y > (prod2 - (vh * .7)) && y < (prod2 + $('#prod2').height()) - (vh * .7)) {

 
          if (trigger2) {
            console.log('drink 2');
            
            $('#cocktail-switcher .info').removeClass('enter').addClass('exit');
          	
   
              $('#info-gfp, #prod-text-2').addClass('enter');
  
            
            trigger2 = false;
          }

      
          trigger1 = true;
          trigger3 = true;
          trigger4 = true;   
		}
		else if (y > (prod3 - (vh * .7)) && y < (prod3 + $('#prod3').height()) - (vh * .7)) {
        
          if (trigger3) {
            console.log('drink 3');
            
            $('#cocktail-switcher .info').removeClass('enter').addClass('exit');
          	
          
              $('#info-99-cents, #prod-text-3').addClass('enter');

            trigger3 = false;
          }


          trigger1 = true;
          trigger2 = true;
          trigger4 = true;
          
		}
		else if (y > (prod4 - (vh * .7)) && y < (prod4 + $('#prod4').height()) - (vh * .7)) {
          
			if (trigger4) {
            console.log('drink 4');
 
              
            $('#cocktail-switcher .info').removeClass('enter').addClass('exit');
          	
         
              $('#info-third-beach, #prod-text-4').addClass('enter');

            
            trigger4 = false;
          }
          

          trigger1 = true;
          trigger2 = true;
          trigger3 = true;
       
          
        } else {

              trigger1 = true;
          trigger2 = true;
          trigger3 = true;
          trigger = true;

          
        }
      
	}


	$(window).scroll(function () {
		checkScroll();
	});

	checkScroll();
    
    
  } else {
    
	function checkScroll() {

		state0 = $('#shopify-section-footer').offset().top;

		var y = $(document).scrollTop()
		var vh = $(window).height();

        if (y > vh) {
          
          // $('.header-dup-wrap').fadeOut();
          $('.header-dup-wrap').addClass('dark');
       
        } else {
//           $('.header-dup-wrap').fadeIn();
           $('.header-dup-wrap').removeClass('dark');
        }
      
      
      	if (y > (state0 - vh)) {

          $('.please-banner-image .button, .block-newsletter').addClass('exit');

        } else {
           $('.please-banner-image .button, .block-newsletter').removeClass('exit');

        }
    }
      

	$(window).scroll(function () {
		checkScroll();
	}).resize(function () {
		checkScroll();
	});

	checkScroll();
    
    
  }
    
    
  
  
   if( $('.product-image video').length )  {
  
      /* play video twice as fast */
    document.querySelector('video').defaultPlaybackRate = 1.0;
    document.querySelector('video').play();

    /* now play three times as fast just for the heck of it */
    document.querySelector('video').playbackRate = 0.5;
     
     
     $('video').get(0).pause();
     
     setTimeout(function(){
       $('video').get(0).play();
     }, 2000);


      $('video').mouseover(function(){
    //     $(this).get(0).pause();
        document.querySelector('video').playbackRate = 0.4;
      });

      $('video').mouseout(function(){
    //     $(this).get(0).play();
         document.querySelector('video').playbackRate = 0.5;
      });
     
   }


   $('.product-form__input label').each(function(){
    var x = $(this).text();
     var z = x.trim();
    console.log(z);

     if (z=="Singles") {
       $(this).append('<span class="new">$4.99</span>');
     } else if (z=="Four Pack") {
       $(this).append('<span>$19.99</span>');
     } else if (z=="750mL Singles") {
       $(this).append('<span>$13.49</span>');
     } else if (z=="Case of 12 x 750mL") {
       $(this).append('<span>$154.49</span>');
     } else if (z=="Case (x24)") {
       $(this).append('<span>$119.00</span>');
     } else {
       
     }
  });
  
  
  // $('.product-form__input label:first-of-type').append('<span>$4.99</span>');
  //$('.product-form__input label:nth-of-type(2)').append('<span>$19.99</span>');
  //$('.product-form__input label:nth-of-type(3)').append('<span>$119.00</span>');
  

 
  /*
  $('label[for=template--16334662271220__main-1-0]').append('<span>$4.99</span>');
  $('label[for=template--16334662271220__main-1-1]').append('<span>$19.99</span>');
  $('label[for=template--16334662271220__main-1-2]').append('<span>$13.49</span>');
  $('label[for=template--16334662271220__main-1-3]').append('<span>$154.49</span>');
  */



  

  
  $(".scrollto").click(function(e) {
    e.preventDefault();

    $("html, body").animate({
      scrollTop: $($(this).attr("href")).offset().top
    }, 800);
  });
  
  
  
  
  
  /* stockist */
  $('.city a').on('click', function(e){
    e.preventDefault();
    
    var x = $(this).attr('href');
    var y = $(this).attr('data-anchor');
    
   $('.city a').removeClass('active');
   $(this).addClass('active');

    $('.business-type').removeClass('active');
    $('#type-selector-'+y+'').addClass('active');
    
	$('.stockist-by-city').removeClass('active');
    $('#'+y+'').addClass('active');

  });
  
  
  
  $('.business-type a').click(function(e){
    e.preventDefault();
    	var x = $(this).attr('data-target');
    	var y = $(this).attr('data-filter');
    
   
    	$('.business-type a').removeClass('active');
   		$(this).addClass('active');
    
    	$('#'+x+'').find('div').fadeOut(200);
    
      setTimeout(function(){
        $('#'+x+'').find('.'+y+'').fadeIn();
      }, 100);
  });


  

  var cartOpen = getUrlVars2()["cart"];
  if (cartOpen == 'open') {
    console.log('open');
    setTimeout(function(){
      window.SLIDECART_OPEN();
    }, 500);
  }

 

   AOS.init({
   duration: 1200 
  });
  
  
  
});